import React from "react";
import FashionTillShell from "./FashionTillShell";
import { formatTillMoney, tillAmountValue } from "./tillFormat";

// Board open-simple: type the opening cash instead of counting denominations.
const FashionOpenAmount = ({
  outlet,
  till,
  currency,
  amountRef,
  inputAmount,
  onAmountChange,
  lastCloseAmount,
  onUseLastClose,
  noteValue,
  setNoteValue,
  onOpenTill,
  onBack,
  tillLoading,
}) => {
  const lastClose = tillAmountValue(lastCloseAmount);
  const symbol = currency?.currSymbol ?? "₹";
  const meta = [till, outlet].filter(Boolean).join(" · ");
  return (
    <FashionTillShell title="Open till" meta={meta} onBack={onBack} testId="fashion-open-amount">
      <section className="ftill-main">
        <div className="ftill-card ftill-open-simple">
          <h1 className="ftill-h1">Open till</h1>
          <p className="ftill-sub">Enter the cash you are starting with.</p>
          <form
            className="ftill-rows"
            style={{ marginTop: 16 }}
            onSubmit={(e) => {
              e.preventDefault();
              onOpenTill();
            }}
          >
            <div className="ftill-field">
              <label className="ftill-label" htmlFor="ftill-open-amount">
                Opening cash {symbol}
              </label>
              <input
                id="ftill-open-amount"
                ref={amountRef}
                className="ftill-input ftill-input--amount"
                inputMode="decimal"
                placeholder="0.00"
                value={inputAmount}
                onChange={onAmountChange}
              />
            </div>
            {lastClose > 0 ? (
              <div className="ftill-row">
                <span>Last close left {formatTillMoney(lastClose, currency)} in the drawer.</span>
                <button type="button" className="ftill-btn ftill-btn--link" onClick={onUseLastClose}>
                  Use this amount
                </button>
              </div>
            ) : null}
            <div className="ftill-field">
              <label className="ftill-label" htmlFor="ftill-open-amount-note">
                Note (optional)
              </label>
              <input id="ftill-open-amount-note" className="ftill-input" value={noteValue} onChange={(e) => setNoteValue(e.target.value)} />
            </div>
            <button type="submit" className="ftill-btn ftill-btn--go ftill-btn--lg ftill-btn--block" disabled={tillLoading}>
              {tillLoading ? "Opening till…" : "Open till"}
            </button>
          </form>
        </div>
      </section>
      <aside className="ftill-side">
        <h2 className="ftill-side__title">Till</h2>
        <div className="ftill-rows">
          <div className="ftill-row">
            <span>Outlet</span>
            <b>{outlet}</b>
          </div>
          <div className="ftill-row">
            <span>Till</span>
            <b>{till}</b>
          </div>
          <div className="ftill-row">
            <span>Left at last close</span>
            <b>{formatTillMoney(lastClose, currency)}</b>
          </div>
          <div className="ftill-row ftill-row--total">
            <span>Opening cash</span>
            <b>{formatTillMoney(inputAmount, currency)}</b>
          </div>
        </div>
      </aside>
    </FashionTillShell>
  );
};

export default FashionOpenAmount;
